/**
 * Created by jonas on 2020-09-17.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {WinWayDisplay} from "../components/WinWayDisplay";
import {DasUBootGameAssets} from "../DasUBootGameAssets";
import {DasUBoot} from "../DasUBoot";
import {SpineGSAPWrapper} from "../../core/animation/SpineGSAPWrapper";
import {gsap} from "gsap";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {DasUBootSound} from "../sound/DasUBootSound";
import {CountUpMultiplier} from "../components/CountUpMultiplier";
import {FreespinReTriggerView} from "./parts/FreespinReTriggerView";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {MathUtils} from "../utils/MathUtils";


enum SpineTracks {
    TEXT_LOOP,
    STAR_ROTATION_LOOP,
    FALLING_GOLD_1_LOOP,
    FALLING_GOLD_2_LOOP,
    FALLING_GOLD_3_LOOP,
    LEVEL_ANIMATION,
    EXPLOSION,

}

export class DasUBootWinView extends PIXI.Container implements StageLayer {
    private _countUp:BasicBitmapCountUp;
    private _winWaysCountUp:WinWayDisplay;
    private _winWaysToggle:WinWayDisplay;
    private _countContainer:PIXI.Container;
    private _bigWin:PIXI.spine.Spine;
    private _winAmountToggle:PIXI.BitmapText;
    private _multiplierToggle:PIXI.Text;
    private _multiplierText:CountUpMultiplier;
    private _freespinReTriggerView:FreespinReTriggerView;
    private _crewReactions:PIXI.spine.Spine;
    private countUpLayer:PIXI.Container;
    private winWayLayer:PIXI.Container;

    constructor() {
        super();
        this.name = "DasUBootWinView";
        this.init();
    }

    private init() {
        this._countUp = new BasicBitmapCountUp({
            fontName:DasUBootGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize:312,
            tint:0xffffff
        }, 720, new PIXI.Point(0.5, 0.5));

        this._countUp.position.set(0, 0);


        this._winWaysCountUp = new WinWayDisplay(true);
        this._winWaysCountUp.position.set(0, 100);


        this._multiplierText = new CountUpMultiplier();
        this._multiplierText.position.set(0, -100);

        this._countContainer = new PIXI.Container();
        this._countContainer.position.set(360, 280);
        this._countContainer.addChild(this._countUp, this._winWaysCountUp, this._multiplierText);


        this._winAmountToggle = new PIXI.BitmapText("", {
            fontName:DasUBootGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize:156 * 0.8,
            tint:0xffffff
        });
        this._winAmountToggle.anchor = new PIXI.Point(0.5, 0.5);
        this._winWaysToggle = new WinWayDisplay(true);
        this._winWaysToggle.position.set(0, 0);


        const multiplierStyle:PIXI.TextStyle = new PIXI.TextStyle({
            fill:0xffffff,
            fontFamily:OpenSans.FAMILY,
            wordWrap:false,
            fontWeight:FontWeight.BOLD,
            fontSize:50,
            dropShadow:true,
            dropShadowAngle:1.5,
            dropShadowBlur:5,
            dropShadowDistance:10,
        });
        this._multiplierToggle = new PIXI.Text("", multiplierStyle);
        this._multiplierToggle.anchor = new PIXI.Point(0.5, 0.5);

        this._freespinReTriggerView = new FreespinReTriggerView();

        this._bigWin = new PIXI.spine.Spine(DasUBoot.assetLoader.getSpineAsset(DasUBootGameAssets.BIG_WIN_SPINE));
        this._bigWin.position.set(360, 360);
        this._bigWin.visible = false;
        this.addChild(this._bigWin);


        this._crewReactions = new PIXI.spine.Spine(DasUBoot.assetLoader.getSpineAsset(DasUBootGameAssets.CREW_REACTIONS_SPINE));
        this._crewReactions.position.set(360, 360);


        this.countUpLayer = new PIXI.Container();
        this.winWayLayer = new PIXI.Container();

        this.addChild(this.winWayLayer);
        this.addChild(this.countUpLayer);

    }

    public getTorpedoMiss():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.addChild(this._crewReactions);
            SpineGSAPWrapper.clearAnimation(this._crewReactions, 0);
            this._crewReactions.updateTransform();
        })
        tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_MISS));
        tl.add(SpineGSAPWrapper.createTimeline(this._crewReactions, 0, "TorpedoMiss"));
        tl.add(() => {
            this.removeChild(this._crewReactions);
        })

        return tl;

    }

    public showWinWayDisplay(winAmount:number, multiplier:number, ways:number, position:PIXI.Point, duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._winAmountToggle.text = DasUBoot.apiPlugin.currency.formatValue(winAmount);
            this._winAmountToggle.position.set(position.x - 4, position.y-1);
            this.winWayLayer.addChild(this._winAmountToggle);

            this._winWaysToggle.setWays(ways);
            this._winWaysToggle.position.set(position.x, position.y + 64+10);
            this.winWayLayer.addChild(this._winWaysToggle);
        })

        tl.add(gsap.to(this, {duration:duration}), "<");
        tl.add(() => {
            this.winWayLayer.removeChild(this._winAmountToggle);
            this.winWayLayer.removeChild(this._winWaysToggle);
        });

        if (duration == 0) {
            tl.progress(1);
        }

        return tl;
    }


    public getCountUpScaleAnimation(fromCount:number, toCount:number, duration:number, fromScale:number, toScale:number):gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(() => {
            this._countUp.scale.set(fromScale, fromScale);
            this._countUp.preCalculateScale(fromCount, toCount);
        });

        tl.add(gsap.to(this._countUp.scale, {duration:duration, x:toScale, y:toScale, ease:"none"}));

        return tl;
    }

    public getWinCountUp(from:number, to:number, duration:number, ways:number = 0, pos:PIXI.Point = new PIXI.Point(360, 360), skipSound:boolean = false, shouldPump:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        const winWaysShowDuration = duration > 0.3 ? 0.3 : 0.01;
        const winWaysShow = this._winWaysCountUp.getShowAnimation(ways, winWaysShowDuration);
        const pumpAnim = gsap.timeline();
        if (shouldPump) {
            pumpAnim.add(gsap.to(this._countContainer.scale, {duration:0.05, x:1.2, y:1.2, ease:"none"}));
            pumpAnim.add(gsap.to(this._countContainer.scale, {duration:0.3, x:1, y:1}));
        }

        tl.add(() => {
            this._countContainer.alpha = 1;
            this._countContainer.position.set(pos.x, pos.y);
            this.countUpLayer.addChild(this._countContainer);
        });

        if (!skipSound) {
            tl.add(() => {
                DasUBoot.soundPlayer.startCountUp();
            })
        }

        if (winWaysShow) {
            tl.add([
                this._countUp.getCountAnimation(from, to, duration),
                winWaysShow,
                pumpAnim
            ]);
        } else {
            tl.add([
                this._countUp.getCountAnimation(from, to, duration),
                pumpAnim
            ]);
        }


        tl.add(() => {
            this._countUp.stopAt(to, false);
        });


        return tl;
    }

    public getWinCountUpEnd(accumulatedRoundWin:number, stayDuration:number, ways:number = 0, endSound:string = "") {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            DasUBoot.soundPlayer.endCountUp(endSound);
            this.countUpLayer.addChild(this._countContainer);
        });
        tl.add(() => {
            this._countUp.stopAt(accumulatedRoundWin, false);
            this._winWaysCountUp.position.set(0, this._countUp.height * 0.5 +10);
            this._winWaysCountUp.scale.set(this._countUp.scale.x + 0.6, this._countUp.scale.y + 0.6);
            this._winWaysCountUp.getShowAnimation(ways, 0.01);
        });

        tl.add(gsap.to(this, {duration:stayDuration}));

        return tl;
    }

    public getWinCountUpFade(accumulatedRoundWin:number, fadeDuration:number = 0.3) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add([
            gsap.to(this._countContainer, {duration:fadeDuration, alpha:0, ease:"none"}),
            gsap.to(this._countContainer.position, {duration:fadeDuration, y:-100, ease:"none"})
        ]);
        tl.add(() => {
            this._multiplierText.reset();
            this.countUpLayer.removeChild(this._countContainer);
            this._countContainer.alpha = 1;
            this._countContainer.position.set(0, 0);
        });

        return tl;
    }

    private startLoopAnimations() {
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.TEXT_LOOP, "textLoop", -1);
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.STAR_ROTATION_LOOP, "starRotationLoop", -1);
    }

    private startParticles(level:number) {
        if (level == 1) {
            SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.FALLING_GOLD_1_LOOP, "fallingGold1", -1);
        }
        if (level == 2) {
            SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.FALLING_GOLD_2_LOOP, "fallingGold2", -1);
        }
        if (level == 3) {
            SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.FALLING_GOLD_3_LOOP, "fallingGold3", -1);
        }
    }

    public getBigWinAnimation(startAnim:string, particleLevel:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => this.startLoopAnimations());

        tl.add(() => {
            this._bigWin.visible = true;
            this._bigWin.alpha = 1;
        })

        tl.add([
            SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.LEVEL_ANIMATION, startAnim),
            () => SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.EXPLOSION, "depthChargeExplosionStartingLevel"),
            () => this.startParticles(particleLevel)
        ]);

        return tl;
    }

    public getBigWinEnd(stayDuration:number = 1):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.EXPLOSION, "depthChargeExplosionStartingLevel")});
        tl.add(gsap.to(this, {duration:stayDuration - 0.3}));
        tl.add(gsap.to(this._bigWin, {duration:0.3, alpha:0, ease:"none"}));
        tl.add(() => this.clearBigWinSpine(), "+=0.01");


        return tl;

    }

    private clearBigWinSpine(){
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.TEXT_LOOP, null);
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.STAR_ROTATION_LOOP, null);
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.FALLING_GOLD_1_LOOP, null);
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.FALLING_GOLD_2_LOOP, null);
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.FALLING_GOLD_3_LOOP, null);
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.LEVEL_ANIMATION, null);
        SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.EXPLOSION, null);

        this._bigWin.visible = false;
        this._bigWin.alpha = 1;
    }


    public getMaxWinAnimation(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this._bigWin.visible = true;
            this.startParticles(1);
        }, 0);

        tl.add(() => {
            this.startParticles(2);
            this.startParticles(3);
            SpineGSAPWrapper.createTimeline(this._bigWin, SpineTracks.EXPLOSION, "depthChargeExplosionStartingLevel")
        }, duration);

        return tl;
    }

    public getMaxWinEnd():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() =>this.clearBigWinSpine(), "+=0.01");
        return tl;
    }

    public getMultiplier(multiplier:number, finalValue:boolean = false, duration:number = 0.3, withExplosion:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(this._multiplierText.getAnimation(multiplier, duration));

        if (withExplosion) {
            tl.add(() => {this.getMultiplierExplosion()}, "<");
        }

        tl.add(() => {
            if (finalValue || withExplosion) {
                DasUBoot.soundPlayer.playSound(DasUBootSound.COUNT_MULTIPLIER_ENDS);
            } else {
                DasUBoot.soundPlayer.playSound(DasUBootSound.COUNT_MULTIPLIER);
            }
        }, 0);

        return tl;
    }

    private getMultiplierExplosion():gsap.core.Timeline {
        const tl = gsap.timeline();

        const spine = DasUBoot.graphicsPool.getSpinePool(DasUBootGameAssets.SMALL_EXPLOSION).withdraw();
        spine.position.set(MathUtils.randomIntFromInterval(-20, 20), MathUtils.randomIntFromInterval(80, 120));
        spine.autoUpdate = false;

        tl.add(() => {
            this._countContainer.addChildAt(spine, 0);
        })
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 0, "bomb"));

        tl.add(() => {
            this._countContainer.removeChild(spine);
            DasUBoot.graphicsPool.getSpinePool(DasUBootGameAssets.SMALL_EXPLOSION).deposit(spine);
        })

        return tl;
    }

    public getFreespinReTriggerAnimation(addedSpins:number, totalSpinsLeft:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            const offset = new PIXI.Point(43, 50);
            if (!NolimitApplication.isLandscape) {
                offset.x = 0;
            }
            const pos = MathUtils.addPoints(DasUBoot.keypadPlugin.getSpinButtonCenter(), offset);
            this._freespinReTriggerView.position.set(pos.x, pos.y);
            this.addChild(this._freespinReTriggerView);
        });
        tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.FREESPIN_RE_TRIGGER));
        tl.add(this._freespinReTriggerView.getAttention());
        tl.add(() => SlotGame.keypadPlugin.setZeroBetSpinCounter(totalSpinsLeft));
        tl.add(this._freespinReTriggerView.getEnding());

        tl.add(() => {
            this.removeChild(this._freespinReTriggerView);
        })

        return tl;
    }
}